module.exports = __webpack_public_path__ + "06_hige_black.df1c6381.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/06_hige_black.png
// module id = JPMK
// module chunks = 0